import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-549296f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "commentContainer" }
const _hoisted_2 = { class: "commentHeadline" }
const _hoisted_3 = { class: "commentDefault" }
const _hoisted_4 = { class: "commentDefault__description" }
const _hoisted_5 = { class: "commentDefault__buttons" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "edit", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "delete", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "commentEdition" }
const _hoisted_11 = { class: "commentEdition__buttons" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "upgrade", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "cancel", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "delete", -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createElementVNode("b", null, _toDisplayString(_ctx.formatName(_ctx.comment.owner.name)), 1),
        _createTextVNode(" el "),
        _createElementVNode("b", null, _toDisplayString(_ctx.comment.date), 1)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.comment.description), 1),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.editable)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "commentDefault__buttons--edit",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state = 'edit'))
            }, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.editable)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "commentDefault__buttons--delete",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteComment && _ctx.deleteComment(...args)))
            }, _hoisted_9))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, _ctx.state === 'default']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.description) = $event)),
        placeholder: "Update comment",
        class: "border"
      }, "\n      ", 512), [
        [_vModelText, _ctx.data.description]
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          class: "commentEdition__buttons--update",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args)))
        }, _hoisted_13),
        _createElementVNode("button", {
          class: "commentEdition__buttons--cancel",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetEdit && _ctx.resetEdit(...args)))
        }, _hoisted_15),
        _createElementVNode("button", {
          class: "commentEdition__buttons--delete",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteComment && _ctx.deleteComment(...args)))
        }, _hoisted_17)
      ])
    ], 512), [
      [_vShow, _ctx.state === 'edit']
    ])
  ]))
}